<template>
  <b-card-body>
    <b-form @submit.prevent="createChannel">
      <b-form-group label-for="website-name" label="Website Name" label-class="font-weight-bold">
        <b-form-input type="text" placeholder="Insert your website name" id="website-name" v-model="configuration.website_name" required />
      </b-form-group>
      <b-form-group label-for="website-domain" label="Website Domain" label-class="font-weight-bold">
        <b-form-input type="text" placeholder="Insert your domain name" id="website-domain" v-model="configuration.website_domain" required />
      </b-form-group>
      <b-form-group label-for="widget-color" label="Widget Color" label-class="font-weight-bold">
        <el-color-picker v-model="configuration.widget_color" required ></el-color-picker>
      </b-form-group>
      <b-form-group label-for="welcome-heading" label="Welcome Heading" label-class="font-weight-bold">
        <b-form-input type="text" placeholder="Insert your welcome heading" id="welcome-heading" v-model="configuration.welcome_heading" required />
      </b-form-group>
      <b-form-group label-for="welcome-tagline" label="Welcome Tagline" label-class="font-weight-bold">
        <b-form-input type="text" placeholder="Insert your welcome tagline" id="welcome-tagline" v-model="configuration.welcome_tagline" />
      </b-form-group>
      <b-form-group label="Access Token">
        <el-input
          v-model="access_token"
          placeholder="Your access token" disabled/>
      </b-form-group>
      <b-form-group label="Script Embed">
        <div class="bd-example text-sm text-monospace" style="position: relative;">
          <el-popover
            placement="top"
            trigger="hover"
            style="position: absolute; top: 10px; right: 10px">
            <p style="white-space: pre-line; overflow-wrap: break-word; word-break: break-all; font-size: 12px;">Copy to clipboard, paste inside <strong>&lt;script&gt;&lt;/script&gt;</strong> tag</p>
            <button slot="reference" type="button" class="btn btn-outline-primary btn-xs" @click="copyScriptEmbed">Copy</button>
          </el-popover>
          <pre id="code-script-embed" class="rounded" style="font-size: 12px">{{ script_embed_webchat_sdk }}</pre>
        </div>
       </b-form-group>
      <!-- <b-button type="submit" variant="primary">{{ $t('general.submit') }}</b-button> -->
    </b-form>
  </b-card-body>
</template>
<script>
import channelsAPI from '../../../api/channels';
import popupErrorMessages from '../../../library/popup-error-messages';

export default {
  name: 'AddTelegramChannel',
  data() {
    return {
      configuration: {
        website_name: '',
        website_domain: '',
        widget_color: '',
        welcome_heading: '',
        welcome_tagline: '',
      },
      timeout: null,
      access_token: '',
    };
  },
  mounted() {
    this.getChannelProfile();
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
    script_embed_webchat_sdk() {
      let script_embed = `(function(d,t) {
  localStorage.setItem("makna-webchat-sdk-api-url", "[sdk-api-url]");
  localStorage.setItem("makna-webchat-sdk-token", "[sdk-token]");
  var g=d.createElement(t),s=d.getElementsByTagName(t)[0],w = d.createElement('div');
  w.setAttribute("id", "makna-sdk");
  g.type="module";
  g.crossorigin="anonymous";
  g.src="[sdk-cdn-url]";
  g.defer = true;
  g.async = true;
  s.parentNode.insertBefore(w,s);
  s.parentNode.insertBefore(g,s);
})(document,"script");`;
      script_embed = script_embed.replace('[sdk-api-url]', (process.env.VUE_APP_WEBCHAT_SDK_API_URL || ''));
      script_embed = script_embed.replace('[sdk-token]', (this.access_token || ''));
      script_embed = script_embed.replace('[sdk-cdn-url]', (process.env.VUE_APP_WEBCHAT_SDK_CDN_URL || ''));
      return script_embed;
    },
  },
  methods: {
    createChannel() {
      this.$emit('createChannel', this.configuration);
    },
    handlerInputToken() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        console.log('testing...');
        const regex = /(\w+):(\w+)/g;
        if (regex.test(this.configuration.token)) {
          // Validate token
          this.checkProfile();
        }
      }, 1000);
    },
    async checkProfile() {
      this.$parent.showLoader();
      await channelsAPI.checkTelegramProfile({
        type: 'telegram',
        token: this.configuration.token,
        workspace_id: this.$parent.activeWorkspace._id,
      }).then(async (response) => {
        await popupErrorMessages(response);
        const { profile } = response.data;
        this.configuration.bot_username = profile.username;
      }).catch(() => {});
      this.$parent.hideLoader();
    },
    async getChannelProfile() {
      await channelsAPI.getChannelProfile({
        workspace_id: this.activeWorkspace._id,
        channel_id: this.$route.params.channel_id,
      }).then(({ data }) => {
        const { profile } = data;
        this.configuration = profile;
        this.access_token = profile.access_token ?? '';
      }).catch((err) => console.log(err));
    },
    copyScriptEmbed() {
      const code_script = document.getElementById('code-script-embed');
      navigator.clipboard.writeText(code_script.innerHTML);
      this.$message({
        message: 'Script copied!',
        type: 'success',
      });
    },
  },
};
</script>
